import React from 'react'

import { Html } from '@application/Interfaces/Atoms/Html'
import type { HeroSectionComponent } from '@application/Types/ComponentTypes'
import { Nullable } from '@application/Types/Opt'
import { parseUtmParamsInHtml } from '@src/Application/Utils/generalUtils'

import { Title } from './HeroHeader.styled'

export const HeroHeader = ({ header, mode }: Pick<HeroSectionComponent, 'header' | 'mode'>): Nullable<JSX.Element> => {
    return (
        <Title $mode={mode}>
            <Html content={parseUtmParamsInHtml(header?.data.childMarkdownRemark.html)} />
        </Title>
    )
}
